import { c as _c } from "react/compiler-runtime";
// `<OgDemoModeBadge>` — bottom-right chrome chip rendered on devnet
// (`?demo-mode`) OG cards.
//
// Why a corner badge instead of inline text? Twitter/Slack/iMessage
// crop and rescale OG cards aggressively in feeds. The corner of the
// 1200×630 frame is the only spot that survives every observed crop
// while staying out of the heading + image content area. A solid
// chip with a high-contrast tint (warning yellow on a dark stroke)
// is legible at thumbnail size — `OG_HERO_PX`-equivalent visibility
// for the badge itself, even if the heading text is unreadable.

import { OG_TOKENS } from '../../tokens';
export function OgDemoModeBadge() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div style={{
      position: "absolute",
      bottom: 32,
      right: 32,
      zIndex: 2,
      display: "flex",
      alignItems: "center",
      gap: 8,
      padding: "12px 18px",
      borderRadius: 9999,
      background: "#1a1305",
      border: `2px solid ${OG_TOKENS.warning500}`,
      color: OG_TOKENS.warning500,
      fontSize: 22,
      fontWeight: 700,
      lineHeight: 1
    }}><span style={{
        display: "block",
        width: 10,
        height: 10,
        borderRadius: 9999,
        background: OG_TOKENS.warning500
      }} />Demo mode</div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}